export default {
  mainBlue: "#1212c9;",
  backgroundGreen: "rgba(163,255,106,0.16);",
  defaultTransition: (type = "all", s = 0.3) => `${type} ease-out ${s}s`,
  boxShadow: "0 0 50px 0 rgba(27,20,100,0.16)"
};